"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryUtils = exports.CATEGORY_FIELD_TYPE = void 0;
var report_1 = require("@shared/types/report");
var lodash_1 = __importDefault(require("lodash"));
var CATEGORY_FIELD_PREFIX = {
    EE: 'Group_',
    360: 'SC'
};
/**
 * matches on e.g. QID_ABC_SC_XYZ
 * QID_ABC is one of the fields mapped to scoring category SC_XYZ
 */
var CATEGORY_SUBFIELD_REGEX_360 = /^(QID\d+((#\d+)?_\d+)?)_(SC\w+)$/;
exports.CATEGORY_FIELD_TYPE = 'Category';
var CategoryUtils = /** @class */ (function () {
    function CategoryUtils(reportType) {
        if (reportType === void 0) { reportType = report_1.REPORT_TYPE.RC; }
        this.reportType = reportType;
    }
    CategoryUtils.prototype.isCategoryField = function (fieldId, fieldset) {
        if (!fieldId || !fieldset || this.reportType === report_1.REPORT_TYPE.RC) {
            return false;
        }
        if (!this.isCategoryFieldId(fieldId)) {
            return false;
        }
        var categoryFieldIds = this.getCategoryFieldIds(fieldId, fieldset);
        return categoryFieldIds.length > 0;
    };
    CategoryUtils.prototype.isCategoryFieldId = function (fieldId) {
        // @ts-ignore
        return lodash_1.default.startsWith(fieldId, CATEGORY_FIELD_PREFIX[this.reportType]);
    };
    CategoryUtils.prototype.isCategoryFilter = function (filter, fieldset) {
        var fieldId = lodash_1.default.get(filter, 'filter.field');
        return this.isCategoryField(fieldId, fieldset);
    };
    CategoryUtils.prototype.getCategoryFieldInfo = function (fieldId, fieldset
    // @ts-ignore
    ) {
        if (this.reportType === report_1.REPORT_TYPE.EE) {
            return this.getEECategoryFieldInfo(fieldId, fieldset);
        }
        if (this.reportType === report_1.REPORT_TYPE.TS) {
            return this.get360CategoryFieldInfo(fieldId, fieldset);
        }
    };
    CategoryUtils.prototype.getCategories = function (fieldset) {
        if (this.reportType === report_1.REPORT_TYPE.EE) {
            return this.getEECategories(fieldset);
        }
        if (this.reportType === report_1.REPORT_TYPE.TS) {
            return this.get360Categories(fieldset);
        }
        return {};
    };
    CategoryUtils.prototype.getCategoryFieldIds = function (fieldId, fieldset) {
        if (this.reportType === report_1.REPORT_TYPE.EE) {
            return this.getEECategoryFieldIds(fieldId, fieldset);
        }
        if (this.reportType === report_1.REPORT_TYPE.TS) {
            return this.get360CategoryFieldIds(fieldId, fieldset);
        }
        return [];
    };
    CategoryUtils.prototype.getEECategoryFieldInfo = function (fieldId, fieldset) {
        if (!lodash_1.default.has(fieldset, ['definition', 'tags', fieldId])) {
            // @ts-ignore
            return;
        }
        var tag = lodash_1.default.get(fieldset, ['definition', 'tags', fieldId]);
        var field = lodash_1.default.get(fieldset, ['definition', 'fields', fieldId]);
        return lodash_1.default.assign({}, tag, field);
    };
    CategoryUtils.prototype.get360CategoryFieldInfo = function (fieldId, fieldset) {
        if (!lodash_1.default.has(fieldset, ['definition', 'fields', fieldId])) {
            // @ts-ignore
            return;
        }
        return lodash_1.default.assign({
            tagId: fieldId,
            fieldIds: this.get360CategoryFieldIds(fieldId, fieldset)
        }, fieldset.definition.fields[fieldId]);
    };
    CategoryUtils.prototype.getEECategories = function (fieldset) {
        return lodash_1.default.get(fieldset, 'definition.tags', {});
    };
    CategoryUtils.prototype.get360Categories = function (fieldset) {
        var _this = this;
        var fieldMap = fieldset.definition.fields;
        var categories = lodash_1.default.pickBy(fieldMap, function (field, fieldId) {
            return _this.isCategoryField(fieldId, fieldset);
        });
        return lodash_1.default.mapValues(categories, function (field, fieldId) {
            return _this.get360CategoryFieldInfo(fieldId, fieldset);
        });
    };
    CategoryUtils.prototype.getEECategoryFieldIds = function (fieldId, fieldset) {
        var field = this.getEECategoryFieldInfo(fieldId, fieldset);
        return lodash_1.default.get(field, 'fieldIds', []);
    };
    CategoryUtils.prototype.get360CategoryFieldIds = function (fieldId, fieldset) {
        // @ts-ignore
        if (!lodash_1.default.startsWith(fieldId, CATEGORY_FIELD_PREFIX[this.reportType])) {
            return [];
        }
        var fieldIds = lodash_1.default.keys(fieldset.definition.fields);
        return lodash_1.default.filter(fieldIds, function (candidateFieldId) {
            return CATEGORY_SUBFIELD_REGEX_360.test(candidateFieldId) && candidateFieldId.endsWith(fieldId);
        });
    };
    return CategoryUtils;
}());
exports.CategoryUtils = CategoryUtils;
